import { Button } from '@mui/material';
import { styled } from '@mui/system';

export const ErrorButton = styled(Button)(({ theme }) => ({
  backgroundColor: theme.palette.red.main,
  color: 'white',
  '&:hover': {
    backgroundColor: theme.palette.red.dark,
  },
}));

export const GreyButton = styled(Button)(({ theme }) => ({
  backgroundColor: theme.palette.grey.dark,
  border: `2px solid ${theme.palette.grey.dark}`,
  color: 'white',
  '&:hover': {
    backgroundColor: theme.palette.grey.darker,
  },
  '&.Mui-focusVisible': {
    boxShadow: `0 0 0 2px ${theme.palette.grey.darker}`,
  },
}));

export const PrimaryButton = styled(Button)(({ theme }) => ({
  backgroundColor: theme.palette.primary.main,
  border: `2px solid ${theme.palette.primary.main}`,
  color: 'white',
  '&:disabled': {
    backgroundColor: 'gray',
    border: '0px',
  },
  '&:hover': {
    backgroundColor: theme.palette.primary.dark,
  },
  '&.Mui-focusVisible': {
    boxShadow: `0 0 0 2px ${theme.palette.primary.dark}`,
  },
}));

export const SecondaryButton = styled(Button)(({ theme }) => ({
  color: theme.palette.primary.main,
  border: `2px solid ${theme.palette.primary.main}`,
  '&:hover': {
    backgroundColor: theme.palette.action.hover,
  },
  '&.Mui-focusVisible': {
    boxShadow: `0 0 0 2px ${theme.palette.primary.dark}`,
  },
  backgroundColor: 'transparent',
}));

export const SuccessButton = styled(Button)(({ theme }) => ({
  backgroundColor: theme.palette.green.main,
  color: 'white',
  '&:hover': {
    backgroundColor: theme.palette.green.darker,
  },
}));

export const TextButton = styled(Button)(({ theme }) => ({
  border: '0px',
  background: 'transparent',
  color: theme.palette.text.secondary,
  '&:hover': {
    color: theme.palette.text.primary,
    backgroundColor: theme.palette.grey.light,
  },
  '&.Mui-focusVisible': {
    boxShadow: `0 0 0 2px ${theme.palette.grey.light}`,
  },
}));

export const DetailButton = styled(Button, {
  shouldForwardProp: (prop) => prop !== 'selected',
})(({ theme, selected }) => ({
  border: '0px',
  borderRadius: '50px',
  color: 'white',
  marginRight: '16px',
  marginTop: '2px',
  background: selected ? theme.palette.primary.main : theme.palette.grey.dark,
  '&:hover': {
    color: selected ? theme.palette.primary.main : theme.palette.text.primary,
    backgroundColor: theme.palette.grey.light,
  },
  '&.Mui-focusVisible': {
    boxShadow: `0 0 0 2px ${theme.palette.grey.light}`,
  },
  '&.Mui-disabled': {
    color: 'white',
    background: selected ? theme.palette.primary.light : theme.palette.grey.main,
  },
}));
